import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Paper, Typography, Alert, Button } from '@mui/material';
import apiClient, { storage, AUTH_KEYS } from '../services/apiClient';

/**
 * Dev-only smoke page. Mount at `/__smoke?t=<token>` to hit `/auth/me`
 * and verify that the axios client + env config + token flow work.
 *
 * This page is removed at the end of Task 5.
 */
export default function DevSmokePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, data: null, error: null });

  useEffect(() => {
    const queryToken = params.get('t');
    if (queryToken) {
      storage.set(AUTH_KEYS.token, queryToken);
    }
    apiClient
      .get('/auth/me')
      .then((res) => setState({ loading: false, ok: true, data: res.data, error: null }))
      .catch((err) =>
        setState({
          loading: false,
          ok: false,
          data: null,
          error: err?.response?.data || err?.message || String(err),
        })
      );
  }, [params]);

  return (
    <Box sx={{ p: 4, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        API Smoke Test — GET /auth/me
      </Typography>
      {state.loading && <Typography>Loading…</Typography>}
      {!state.loading && state.ok && <Alert severity="success">Backend reachable</Alert>}
      {!state.loading && !state.ok && (
        <Alert severity="error">
          {typeof state.error === 'string' ? state.error : JSON.stringify(state.error, null, 2)}
        </Alert>
      )}
      <Paper sx={{ mt: 2, p: 2, maxHeight: 500, overflow: 'auto' }}>
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 12 }}>
          {state.data ? JSON.stringify(state.data, null, 2) : ''}
        </pre>
      </Paper>
      <Button
        sx={{ mt: 2 }}
        variant="outlined"
        onClick={() => {
          storage.remove(AUTH_KEYS.token);
          storage.remove(AUTH_KEYS.refreshToken);
          storage.remove(AUTH_KEYS.user);
          window.location.reload();
        }}
      >
        Clear auth & reload
      </Button>
    </Box>
  );
}
